const EntityProperty = Object.freeze({
  ASSIGNEE: 'person_uuid',
  BUDGET: 'budget',
  CREATED_AT: 'created_at',
  DESCRIPTION: '__description',
  ACTIVITY_TYPE_DESCRIPTION: 'description',
  EXTERNAL_ID: 'external_id',
  FTE: 'fte',
  HOURS: 'hours',
  IS_MANAGER: 'is_manager',
  LEVEL: 'level',
  NAME: 'name',
  OWNER: 'owner_uuid',
  PROPERTIES: 'properties',
  SKILLS: 'skills',
  TAGS: 'tags',
  TITLE: 'title',
  UUID: 'uuid',
});

export default EntityProperty;
